import { exportCsv } from './export-csv'

const getHeaderRow = () => {
    return [
        'Report Number',
        'Event Type',
        'From', 
        'To',
        'Status',
        'Crew',
        'Passengers',
        'Position',
        'Voyage From',
        'Voyage To',
        'Voyage Number',
        'Distance Sailed (NM)',
        'Time Sailing (Hours)',
        'Time Loading/Unloading (Hours)',
        'Time at Anchor (Hours)',
        'Timezone',
        'Cargo Weight (Mt)', 
        'Draft Fwd (m)',
        'Draft Aft (m)',
        'Power (kw)',
        'Fuel Temp at Engine FM (degrees Celsius)',
        'Density at 15 degrees Celsius (Kg/m3)',
        'Shore Power',
        'Shore Power Hours',
        'Consumption 1',
        'Main Engine 1',
        'Aux Engine 1',
        'Boiler 1',
        'Consumption 2',
        'Main Engine 2',
        'Aux Engine 2',
        'Boiler 2',
        'Consumption 3',
        'Main Engine 3',
        'Aux Engine 3',
        'Boiler 3',
        'Consumption 4',
        'Main Engine 4',
        'Aux Engine 4',
        'Boiler 4',
    ]
}

const extractConsumptions = (report) => {
    return report.consumptions.map(c => [
        (c.hasOwnProperty('bdn_number')) ? c.bdn_number : c.fuel_grade,
        c.main_engine,
        c.aux_engine,
        c.boiler
    ]);
}

const getReportRow = (report) => {
    const baseRow = [
        report.report_number,
        report.event_type,
        report.report_from,
        report.report_to,
        report.status,
        report.crew,
        report.passengers,
        [
            `${report.lat_hours}°`.replace('°', '\u00B0'),
            `${report.lat_minutes}'`,
            `${report.lat_seconds}''`,
            `${report.lat_direction}`,
            `${report.lon_hours}°`.replace('°', '\u00B0'),
            `${report.lon_minutes}'`,
            `${report.lon_seconds}''`,
            `${report.lon_direction}`
        ].join(' '),
        report.voyage_from,
        report.voyage_to,
        report.voyage_number || '',
        report.distance_sailed_NM,
        report.hours_spent_sailing,
        report.hours_spent_loading_unloading,
        report.hours_spent_at_anchor,
        report.timezone || '',
        report.cargo_weight_Mt, 
        report.draft_fwd || '',
        report.draft_aft || '',
        report.power || '',
        report.fuel_temp || '',
        report.density || '',
        report.shore_power || '-',
        report.shore_power_hours || '-',
    ]

    return [
        ...baseRow,
        ...extractConsumptions(report),
    ]
} 

const getReportRows = (reports) => {
    return reports.map(report => {
        return getReportRow(report)
    })
}

export const exportOffshoreReports = (reports, reportName) => {
    const rows = [
        getHeaderRow(),
        ...getReportRows(reports)
    ]

    exportCsv(rows, reportName)
}